import {
  formatAddress,
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import TableCardMobile from '../../../molecules/Table/mobile/TableCard';
import StatsMobile, { IStatsMobileProps } from '../mobile/Stats';
import Loader from '../../common/Loader';
import { onWalletScan } from '../../../helpers/addressUtils';
import NumberDisplay from '../../../molecules/NumberDisplay';
import { getTopTraderPnL } from './Table';
import TableHeaderMobile from '../../../molecules/Table/mobile/TableHeader';

interface ITopTradersTableMobileProps {
  exchange: string;
  chain: string;
  loading: boolean;
  address: string | undefined;
  wallets: any[];
  flipped: boolean;
  timezone?: string;
}

const TopTradersTableMobile = ({
  wallets,
  loading,
  exchange,
  address,
  chain,
  flipped,
  timezone,
}: ITopTradersTableMobileProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: '№',
        accessor: 'id',
        parser: (value) => value,
        width: 40,
      },
      item_2: {
        name: 'Avg Sell Price ($)',
        accessor: 'avg_usd_sell',
        parser: (value) => (
          <NumberDisplay value={value} zeroValueDisplay='-' string />
        ),
        width: 95,
        string: true,
      },
      item_3: {
        name: 'Avg Buy Price ($)',
        accessor: 'avg_usd_buy',
        parser: (value) => (
          <NumberDisplay value={value} zeroValueDisplay='-' string />
        ),
        string: true,
      },
    },
    row_2: {
      item_1: {
        name: 'Trading Volume ($)',
        accessor: 'volume_usd',
        parser: (value) => <NumberDisplay value={value} string />,
        width: 155,
        string: true,
      },
      item_2: {
        name: 'PnL',
        accessor: 'pnl',
        parser: (_, row) => (
          <NumberDisplay
            value={getTopTraderPnL(row.avg_usd_buy, row.avg_usd_sell)}
            endSymbol='%'
            zeroValueDisplay='-'
            string
          />
        ),
        string: true,
      },
    },
    row_3: {
      item_1: {
        name: 'Wallet',
        accessor: 'wallet',
        parser: (value) => formatAddress(value),
        onClick: (row) => onWalletScan(row.wallet, chain),
        color: 'navy',
        width: 95,
      },
    },
  };

  const renderFooter = (props: any) => <StatsMobile {...props} />;

  const footerData: Omit<IStatsMobileProps, 'data' | 'actionShowModal'> = {
    address,
    chain,
    exchange,
    short: true,
    timezone,
  };

  const getColorForItem = (row: any) => {
    if (row.buy_count > 0 && row.sell_count > 0) {
      return 'grey';
    }
    if (row.buy_count > 0) {
      return flipped ? 'red' : 'green';
    }
    return flipped ? 'green' : 'red';
  };

  return (
    <div className='dex_trades_mobile__table'>
      {loading ? (
        <div className='centrify'>
          <Loader />
        </div>
      ) : !wallets.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        <>
          <TableHeaderMobile schema={schema} />
          {formatMobileTableData({
            data: wallets,
            schema,
            getColorForItem,
            renderFooter,
            footerData,
          })?.map((row, index) => (
            <TableCardMobile key={index} data={row} />
          ))}
        </>
      )}
    </div>
  );
};

export default TopTradersTableMobile;
